import React from 'react';
import { Redirect, Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { AuthContext } from './Features/Authentication/AuthContext';
import { Home } from './Features/Home/views/Home';
import { Login } from './Features/Login/views/Login';
import { RecoveryPassword } from './Features/Login/views/RecoveryPassword';
import { LoginBoticario } from './Features/Login/views/LoginBoticario';

export function Routes() {

    function PrivateRoute({ children, ...rest }: any) {
        const auth = React.useContext(AuthContext);
        return (
            <Route
                {...rest}
                render={({ location }) =>
                    auth.login.token != '' ? (
                        children
                    ) : (
                        <Redirect
                            to={{
                                pathname: '/login',
                                state: { from: location }
                            }}
                        />
                    )
                }
            />
        );
    }

    return (
        <Router>
            <Switch>
                <Route path="/login">
                    <Login />
                </Route>
                <Route path="/boticario/login">
                    <LoginBoticario />
                </Route>
                <Route path="/recovery-password">
                    <RecoveryPassword />
                </Route>
                <PrivateRoute exact path="/">
                    <Home />
                </PrivateRoute>
                <PrivateRoute path="*">
                    <Home />
                </PrivateRoute>
            </Switch>
        </Router>
    );
}